import { explicitMaybe } from '@execonline-inc/decoders';
import { Decoder, field, number, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../Resource/Decoders';
import { TestLearningCollection, TestLearningCollectionResource } from './Types';

export const updateLearningCollectionDecoder: Decoder<{}> = succeed({});

export const createLearningCollectionDecoder: Decoder<TestLearningCollection> = succeed({}).assign(
  'id',
  field('id', explicitMaybe(number)),
);

export const createLearningCollectionResourceDecoder: Decoder<TestLearningCollectionResource> =
  resourceDecoder(createLearningCollectionDecoder);
